// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	api_url: 'https://bzapi.dev.testtory.com/',
	docker: 0,
	ms: {
		sso: 'sso-ms',
		sale: 'sale-ms', // invoice
		user: 'user-ms', // No user ms
		report: 'report-ms',
		account: 'account-ms',
	},
	docker_api_url: {
		sso: 'http://localhost:5000/',
	},
	subdomain: 'testtory.com',
	new_api_url: 'https://bzapi.dev.testtory.com/',
};

export const s3Asset = 'https://cdn.biztoryapp.com/staging/bzai/v2/assets';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
export const baseTranslateUrl = '/assets/i18n';

export const redirect_url = '.testtory.com';

export const base_url = 'https://';

export const facebook = {
	version: 'v10.0',
};

export const GQLUrl = {
	// add more micro services here
	sso: `${environment.new_api_url}api/sso-ms/graphql`,
};

export const facebookProvider = '604612013032858';

export const googleProvider = '85806127863-6bf6of3dpkfqh1sio5197evdilp8nr4g.apps.googleusercontent.com';

export const consolidateURL = 'https://consolidate-staging.biztoryapp.com';

export const subdomain = undefined;
export const API_URL = 'https://bzai-api2-staging.biztoryapp.com';
export const NEW_API_URL = 'https://bzapi.dev.testtory.com';
export const MICRO_SERVICES = [
	'sso-ms',
	'invoice-ms', // invoice-ms
	'user-ms',
	'report-ms',
	'account-ms',
	'util-ms',
	'third-party-ms',
	'template',
	'transaction-ms',
	'inventory-ms',
] as const;
export const MICRO_SERVICES_ENDPOINT = [
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	API_URL,
	NEW_API_URL,
	NEW_API_URL,
] as const;
